import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {connectModuleEnv} from '../../oe-module-env';
import {withIsOpenState, frefFromRef, frefToRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OELicensingAccessProvider from '../../../react-oe/oe-licensing-access-provider';
import OENotification from '../../../lib/notification/oe-notification';
import OEAnimateHelper from '../../../lib/animation/oe-animate-helper';
import {OEViewType} from '../../../lib/oe-types';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import {OEIconButton} from '../../elements/controls/oe-button';

export class OEImplantcastRegisterNoticeViewUnconnected extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            strings: {
                message:        '',
                buttonLabel:    '',
                email:          '',
                emailText:      ''
            },
            link: ''
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onRegisterButtonPressed = this.onRegisterButtonPressed.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.setState({
            strings: {
                message:        si.getLocalizedStringEnc('implantcast_register_message'),
                buttonLabel:    si.getLocalizedStringEnc('implantcast_register_button'),
                email:          si.getLocalizedStringEnc('implantcast_register_email'),
                emailText:      si.getLocalizedStringEnc('implantcast_register_email_text')
            },
            link:               si.getLocalizedStringEnc('implantcast_register_link')
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    renderView()    {
        let style = {left: this.props.offsets.left, transition: OEAnimateHelper.transitionForInsets(this.props.offsets.animate)};

        if(!this.props.isOpen)  {
            style.visibility = 'hidden';
            style.opacity = '0';
        }

        style.transition = style.transition + (style.transition.length ? ', ' : '') + 'visibility 0.333s ease-in-out, opacity 0.333s ease-in-out';

        return (
            <div className="register-notice-view" style={style}>

                <div className="register-notice-container">

                    {!this.props.onCloseBtnPressed ? null :
                        <OEIconButton
                            className="transparent-btn close-btn"
                            icon={OEIconCodes.implantcast.registerClose}
                            onPressed={this.props.onCloseBtnPressed}
                        />
                    }

                    <span className="register-notice-msg">
                        {this.state.strings.message}
                    </span>

                    <a className="register-notice-btn" onClick={this.onRegisterButtonPressed}>
                        <span>{this.state.strings.buttonLabel}</span>
                    </a>

                    <span className="register-notice-email">
                        {this.state.strings.emailText}{' '}
                        <a href={`mailto:${this.state.strings.email}`}>{this.state.strings.email}</a>
                    </span>

                </div>

                <div className="register-notice-spacer"></div>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                {/*this.props.isOpen ? */this.renderView()/* : null*/}

            </React.Fragment>
        );
    }

    onRegisterButtonPressed()    {
        if(typeof(this.state.link) !== 'string' || !this.state.link.length || this.state.link == '#null')  {
            console.log('Warning - no proper link provided to implantcast register view.');
        } else {
            window.open(this.state.link);
        }
    }
}

OEImplantcastRegisterNoticeViewUnconnected.defaultProps = {
    moduleId:                   '',
    isOpen:                     true
};

OEImplantcastRegisterNoticeViewUnconnected.propTypes = {
    moduleId:                   PropTypes.string,
    isOpen:                     PropTypes.bool,
    onCloseBtnPressed:          PropTypes.func
};

export const OEImplantcastRegisterNoticeView = frefFromRef(connectModuleEnv((env) => {
    return {
        offsets: {
            left:               env.ui.leftSlideInContainer.offset,
            animate:            {left: env.ui.leftSlideInContainer.animate}
        }
    };
})(frefToRef(OEImplantcastRegisterNoticeViewUnconnected)));

//
export class OEImplantcastRegisterNoticeControllerUnconnected extends React.PureComponent {

    constructor(props) {
        super(props);

        //
        this.blockingViewTypes = [OEViewType.start, OEViewType.welcome, OEViewType.info, OEViewType.help, OEViewType.manual, OEViewType.screenshot, OEViewType.startSelection];

        //
        this.openTimeOut = 10000;
        this.closeTimeOut = -1;                 // for values < 0 the view will not get closed, this is for debugging or layouting purpose

        //
        this.shown = false;

        //
        this.licensingAccess = OELicensingAccessProvider.defaultLicensingAccess();

        this.onViewOpenStateChanged = this.onViewOpenStateChanged.bind(this);

        this.onOpenTimer = this.onOpenTimer.bind(this);
        this.onCloseTimer = this.onCloseTimer.bind(this);

        this.onLicensingAccess = this.onLicensingAccess.bind(this);

        this.onCloseBtnPressed = this.onCloseBtnPressed.bind(this);
    }

    registerOnViewOpenStateChanged(props)    {
        props = props || this.props;

        this.unregisterOnViewOpenStateChanged(props);

        if(props.appComponent && props.appComponent.uiLayer) {
            props.appComponent.uiLayer.notificationCenter.register(OENotification.viewOpenStateChanged, this.onViewOpenStateChanged);
        }
    }

    unregisterOnViewOpenStateChanged(props)    {
        props = props || this.props;
        
        if(props.appComponent && props.appComponent.uiLayer) {
            props.appComponent.uiLayer.notificationCenter.unregister(OENotification.viewOpenStateChanged, this.onViewOpenStateChanged);
        }
    }

    componentDidMount()    {
        this.debugOut('Register Notice - componentDidMount');
        this.mounted = true;
        this.tryOpen();
        this.registerOnViewOpenStateChanged();
    }

    componentWillUnmount()  {
        this.debugOut('Register Notice - componentWillUnmount');
        this.unregisterOnViewOpenStateChanged();
        this.mounted = false;
        this.clearOpenTimer();
        this.clearCloseTimer();
    }

    componentWillReceiveProps(nextProps)   {
        if(this.props.isOpen != nextProps.isOpen || this.props.appComponent != nextProps.appComponent || this.props.openState != nextProps.openState)   {
            this.debugOut('Register Notice - componentWillReceiveProps');

            if(this.props.appComponent != nextProps.appComponent)   {
                this.unregisterOnViewOpenStateChanged();
                this.registerOnViewOpenStateChanged(nextProps);
            }

            this.tryOpen(nextProps);
            this.tryClose(nextProps, true);
        }
    }

    onConnect()  {
        this.debugOut('Register Notice - onConnect');
        this.connected = true;
        this.shown = false;
        if(this.props.openState)    this.props.openState.setOpen(false);
        this.tryOpen();
    }

    onRelease()    {
        this.debugOut('Register Notice - onRelease');
        this.connected = false;
        this.clearOpenTimer();
        this.clearCloseTimer();
    }

    onViewOpenStateChanged(message, userInfo)    {
        if(!this.blockingViewTypes.includes(userInfo.type)) return;

        this.debugOut('Register Notice - onViewOpenStateChanged - viewType: ' + userInfo.type);

        if(this.canOpen()) {
            this.tryOpen();
        } else {
            this.clearOpenTimer();
        }
    }

    startOpenTimer()    {
        this.clearOpenTimer();
        if(!this.mounted)   return;
        this.debugOut('Register Notice - startOpenTimer');
        this.openTimer = setTimeout(this.onOpenTimer, this.openTimeOut);
    }

    clearOpenTimer()   {
        if(!this.openTimer)  return;
        this.debugOut('Register Notice - clearOpenTimer');
        clearTimeout(this.openTimer);
        this.openTimer = null;
    }

    startCloseTimer()    {
        this.clearCloseTimer();
        if(!this.mounted || this.closeTimeOut < 0)   return;
        this.debugOut('Register Notice - startCloseTimer');
        this.closeTimer = setTimeout(this.onCloseTimer, this.closeTimeOut);
    }

    clearCloseTimer()   {
        if(!this.closeTimer)  return;
        this.debugOut('Register Notice - clearCloseTimer');
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
    }

    shouldOpenLicensing()   {
        return this.licensingAccess.isConnected && this.licensingAccess.isLicensing && !this.licensingAccess.isValid;
    }

    shouldOpen(props)    {
        props = props || this.props;
        return this.connected && !this.shown && !props.isOpen && !!props.appComponent && !!props.openState && this.shouldOpenLicensing();
    }

    canOpen(props)   {
        props = props || this.props;

        let viewType = this.blockingViewTypes.find((type) => {
            let view = OEViewType.getRef(type, props.appComponent);
            return view && view.isOpen();
        });

        if(!!viewType)   return false;

        return true;
    }

    tryOpen(props)   {
        if(this.openTimer || !this.shouldOpen(props) || !this.canOpen(props))    return;

        this.debugOut('Register Notice - tryOpen');

        this.clearCloseTimer();

        this.startOpenTimer();
    }

    tryClose(props, delayed = false)   {
        props = props || this.props;

        if((this.closeTimer && delayed) || !props.isOpen || this.shouldOpen(props))    return;

        this.debugOut('Register Notice - tryClose - delayed: ' + delayed);

        this.clearOpenTimer();

        if(delayed)    {
            this.startCloseTimer();
            return;
        }

        this.clearCloseTimer();

        if(props.openState && this.closeTimeOut >= 0)    props.openState.setOpen(false);
    }

    onOpenTimer()   {
        this.debugOut('Register Notice - onOpenTimer');

        this.openTimer = null;

        if(!this.canOpen() || !this.shouldOpen()) {
            if(this.shouldOpen())   this.startOpenTimer();
            return;
        }

        this.shown = true;
        if(this.props.openState)    {
            this.debugOut('Register Notice - onOpenTimer - setOpen: true');
            this.props.openState.setOpen(true);
        }
    }

    onCloseTimer()   {
        this.debugOut('Register Notice - onCloseTimer');

        this.closeTimer = null;

        if(this.props.openState)    {
            this.debugOut('Register Notice - onCloseTimer - setOpen: false');
            this.props.openState.setOpen(false);
        }
    }

    onLicensingAccess(licensingAccess) {
        if(OEToolbox.shallowEqual(this.licensingAccess, licensingAccess, true)) return;
        this.licensingAccess = licensingAccess;

        this.debugOut('Register Notice - onLicensingAccess - connected: ' + licensingAccess.isConnected + ', licensing: ' +  licensingAccess.isLicensing + ', valid: ' + licensingAccess.isValid);

        this.tryOpen();
        if(!this.shouldOpenLicensing())   this.tryClose();
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OELicensingAccessProvider moduleId={this.props.moduleId} omitUpdateOnRelease={true} onLicensingAccess={this.onLicensingAccess}/>

                <OEImplantcastRegisterNoticeView moduleId={this.props.moduleId} isOpen={this.props.isOpen} onCloseBtnPressed={this.onCloseBtnPressed}/>
            </React.Fragment>
        );
    }

    onCloseBtnPressed() {
        this.clearCloseTimer();

        if(this.props.openState)    this.props.openState.setOpen(false);
    }

    debugOut(str)   {
        //console.log(str);
    }
};

OEImplantcastRegisterNoticeControllerUnconnected.defaultProps = {
    moduleId:                   '',
    isOpen:                     true
};

OEImplantcastRegisterNoticeControllerUnconnected.propTypes = {
    moduleId:                   PropTypes.string,
    isOpen:                     PropTypes.bool
};

export const OEImplantcastRegisterNoticeController = withIsOpenState(frefFromRef(connectAppEnv((env) => {
    return {
        appComponent:           env.component
    };
})(frefToRef(OEImplantcastRegisterNoticeControllerUnconnected))));